import Axios from "axios";
import { ApiBaseUrl, SupplierNoticeBaseUrl } from "../config/config";
import { DocumentUrl } from "../models/cartable.model";
import { ApiResultModel } from "../models/common.model";
import {
  AddAttachmentRequest,
  BasicNoticeResponse,
  DeleteAttachmentRequest,
  GetAllSuppliersInfoRequest,
  GetAllSuppliersInfoResponse,
  GetSupplierNoticesRequest,
  NoticeItemDetail,
  NoticeItemRequest,
  NoticeItemResponse,
  ShowItemRequest,
  UpdateNoticeItemRequest,
} from "../models/supplierNotice.model";
import { boolean } from "yup";
import { number } from "prop-types";
import { GetStatusResponse } from "../models/basicInformation.model";

export const GetAllNotices = (
  request: GetSupplierNoticesRequest
): Promise<ApiResultModel<BasicNoticeResponse[]>> => {
  return Axios.post<ApiResultModel<BasicNoticeResponse[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetAll",
    request
  ).then((result) => {
    return result.data;
  });
};

export const InsertNotice = (
  request: NoticeItemRequest
): Promise<ApiResultModel<NoticeItemResponse>> => {
  const formData = new FormData();
  formData.append("title", request.title);
  formData.append("noticeType", request.noticeType.toString());
  formData.append("body", request.body);
  formData.append("rawBody", request.rawBody);
  formData.append("canSendSms", JSON.stringify(request.canSendSms));
  formData.append("showInLoginPage", JSON.stringify(request.showInLoginPage));
  formData.append(
    "expirationDate",
    request.expirationDate ? new Date(request.expirationDate!).toUTCString() : ""
  );
  formData.append("smsData", request.title);
  const suppList = request.supplierIdList;
  suppList?.forEach((item: any) => {
    formData.append("supplierIdList", item);
  });
  const attach = request.attachments;
  attach?.forEach((item: any) => {
    formData.append("attachments", item.fileData);
  });
  return Axios.post<ApiResultModel<NoticeItemResponse>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/Insert",
    formData
  ).then((result) => {
    return result.data;
  });
};

export const UpdateNotice = (
  request: UpdateNoticeItemRequest
): Promise<ApiResultModel<boolean>> => {
  const formData = new FormData();
  formData.append("title", request.title);
  formData.append("noticeType", request.noticeType.toString());
  formData.append("body", request.body);
  formData.append("canSendSms", JSON.stringify(request.canSendSms));
  formData.append("showInLoginPage", JSON.stringify(request.showInLoginPage));
  formData.append(
    "expirationDate",
    new Date(request.expirationDate!).toUTCString()
  );
  formData.append("smsData", "");
  const suppList = request.supplierIdList;
  suppList?.forEach((item: any) => {
    formData.append("supplierIdList", item);
  });
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/Update",
    request
  ).then((result) => {
    return result.data;
  });
};

export const ShowItemNotice = (
  request: ShowItemRequest
): Promise<ApiResultModel<NoticeItemDetail>> => {
  return Axios.post<ApiResultModel<NoticeItemDetail>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/ShowItem",
    request
  ).then((result) => {
    return result.data;
  });
};

export const DeleteAttachmentNotice = (
  request: DeleteAttachmentRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/DeleteAttachment",
    request
  ).then((result) => {
    return result.data;
  });
};

export const AddAttachmentNotice = (
  request: AddAttachmentRequest
): Promise<ApiResultModel<DocumentUrl[]>> => {
  const formData = new FormData();
  formData.append("noticeKey", request.noticeKey);
  if (request.files[0].file) {
    formData.append("files", request.files[0].file);
  }
  // const attach = (request.files);
  // formData.append("files", request.files.dataurl);
  // attach?.forEach((item: any) => {
  //   formData.append("files", item);
  // })
  return Axios.post<ApiResultModel<DocumentUrl[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/AddAttachment",
    formData
  ).then((result) => {
    return result.data;
  });
};

export const DeleteNotice = (
  request: ShowItemRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/Delete",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetNoticeTypes = (): Promise<GetStatusResponse[]> => {
  return Axios.post<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetNoticeTypes"
  ).then((result) => {
    return result.data.data;
  });
};


export const GetAllSuppliersInfo = (
  request: GetAllSuppliersInfoRequest
): Promise<ApiResultModel<GetAllSuppliersInfoResponse[]>> => {
  return Axios.post<ApiResultModel<GetAllSuppliersInfoResponse[]>>(
    ApiBaseUrl + SupplierNoticeBaseUrl + "/GetAllSuppliersInfo",
    request
  ).then((result) => {
    return result.data;
  });
}